export function returnFileSize(number: number, fixed = 2) {
  if (number < 1024) {
    return `${number} bytes`;
  } else if (number > 1024 && number < 1048576) {
    return `${(number / 1024).toFixed(fixed)} KB`;
  } else {
    return `${(number / 1048576).toFixed(fixed)} MB`;
  }
}
